module.exports = __webpack_public_path__ + "img/supplychain-banner.77d29eb7.png";